import { render, staticRenderFns } from "./ShootingDetailsCard.vue?vue&type=template&id=ccc2cb4a&scoped=true"
import script from "./ShootingDetailsCard.vue?vue&type=script&lang=js"
export * from "./ShootingDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ShootingDetailsCard.vue?vue&type=style&index=0&id=ccc2cb4a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc2cb4a",
  null
  
)

export default component.exports